module.exports = __webpack_public_path__ + "img/add-payment-icon.96569ac8.svg";